var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "notes" } }, [
    !!this.notes.length
      ? _c(
          "div",
          { attrs: { id: "visitor-notes" } },
          _vm._l(_vm.notes, function (note) {
            return _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "name-date" }, [
                _c("div", { staticClass: "agent-name" }, [
                  _vm._v(_vm._s(note.representativeName)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    staticClass: "date",
                    attrs: {
                      content: _vm.$moment(note.createdAt).format("LLL"),
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$moment(note.createdAt).fromNow()) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "agent-note" }, [
                _vm._v(_vm._s(note.representativeNote)),
              ]),
            ])
          }),
          0
        )
      : _c("div", { staticClass: "data-box" }, [_vm._m(0)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "last-session-info" }, [
      _c(
        "div",
        { staticClass: "material-icons", staticStyle: { "font-size": "20px" } },
        [_vm._v("block")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "last-session-data",
          staticStyle: { "margin-top": "5px" },
        },
        [_vm._v("No user data were found")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }